// extracted by mini-css-extract-plugin
module.exports = {"boardForPics":"boardForPics--KUs3f","pages":"pages--lTVW2"};